import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Sidebar from "../../layouts/sidebar";
import Header from "../../layouts/header";
import Layout from "../../layouts/layout";
import Index from "../ConsolidatedReport";


export default function ConsolidateReport() {
  return (
    <>
      <Sidebar />
      <Header />
      <Layout>
        <Index />
      </Layout>
    </>
  );
}
